import { ListableString } from "./data";

export interface User extends ListableString {
  identifier: string;
  signin_code: string;
}

export const UserFields: string[] = ["identifier"];
